export const ASSERTION_REQUIRED_TOOLTIP = "Add an assertion to test this signal";
export const SIGNAL_SAMPLE_PLAYGROUND_RUN_LABEL = "Playground Run";
export const SIGNAL_SAMPLE_PLAYGROUND_RUN_TAG = "playground-run";
export const SIGNAL_SAMPLE_REQUEST_FALLBACK_LABEL = "Request";
export const SIGNAL_COMPACT_REQUEST_ROW_HEIGHT_REM = 7;
export const SIGNAL_SAMPLE_REQUEST_LIMIT = 20;
export const SIGNAL_SKELETON_ROW_KEYS = ["row-1", "row-2", "row-3", "row-4", "row-5"] as const;

export const DRAWER_PEEK_HEIGHT = 42;
export const DRAWER_COLLAPSE_THRESHOLD = 120;
export const DRAWER_DEFAULT_HEIGHT = 280;
export const DRAWER_MIN_HEIGHT = 220;
export const DRAWER_MAX_HEIGHT_RATIO = 0.6;
